import React from 'react';
import { withRouter } from 'react-router-dom';
import styles from '../../constants/stylesDefault';
import InviteRenterForm from '../../components/InviteRenterForm/InviteRenterForm';
import SmallPaper from '../../components/Layout/SmallPaper';

const InviteRenterPage = props =>
  <SmallPaper>
    <div style={styles.center}>
      <img alt="Koboo" src="/logo.svg" style={styles.logo}/>
    <InviteRenterForm history={props.history}/>
    </div>
  </SmallPaper>;

export default withRouter(InviteRenterPage);



// WEBPACK FOOTER //
// ./src/containers/InviteRenterPage/InviteRenterPage.jsx